<template>
    <component :is="termsComponent" @close="$emit('close')" />
</template>

<script>
import { mapState } from 'vuex'
import TermsOfService1123038 from './TermsOfService1123038'
import TermsOfService1123039 from './TermsOfService1123039'

// 游戏单号 -> 服务条款组件
const TERMS_COMPONENTS = {
    '1123038': TermsOfService1123038,
    '1123039': TermsOfService1123039,
}

export default {
    name: 'TermsOfService',
    computed: {
        ...mapState({
            appConfig: state => state.app.appConfig,
        }),
        termsComponent() {
            // 1123038（谷歌6包）、1123039（34包）使用各自独立的服务条款组件
            return TERMS_COMPONENTS[`${this.appConfig.game_id}`] || TermsOfService1123039
        },
    },
}
</script>
